<template>
    <div style="height: inherit;">
      <div v-if="loading" style="height: inherit;">
        <loading-page ref="loadingPage"></loading-page>
      </div>
      <div v-else style="height: inherit;">
        <Header :image="image"/>

        <div class="content__positioning distancing driver__terms">

                    <h1 class="headlin-text">Advertiser Terms and Conditions</h1>
          <div v-html="text" class="adivi-text text"></div>
          <!-- <p class="api-text text">{{text}}</p> -->
          <!-- <pre class="api-text text" id="pre-tag-advertiserts" style="margin-top: 4%;">{{ text }}</pre> -->
          <div class="go-back-btn">
            <button class="btn-back" @click="$router.go(-1)">
              <span class="btn__text__normal">Back</span>
            </button>
          </div>
        </div>

       <footer-view></footer-view>
      </div>
    </div>
</template>

<script>
import HTTPRequest from '../../../plugins/utils/HttpRequest.js'
// import Config from '../../../plugins/utils/Config.js'
import Header from './../../../components/design/HeaderDesign.vue'
import LoadingPage from './../../../components/loading/LoadingScreen.vue'
import FooterView from './../../../components/footer/FooterView.vue'
import toast from '@utils/toast'
export default {
  name: 'AdvertiserTermsAndConditions',
  data: function () {
    return {
      text: '',
      // config: Config,
      loading: true,
      image: 'ts'
    }
  },
  components: {
    Header,
    FooterView,
    LoadingPage
  },
  created: function () {
    this.makeApiCall()
  },
  methods: {
    makeApiCall () {
      var request = new HTTPRequest()
      var url = '/get/t&c'
      var body = {
        API_KEY: '',
        data: {
          format: 'html'
        }
      }
      request.makeRequest('POST', url, body).then((response) => {
        // eslint-disable-next-line camelcase
        var json_response = JSON.parse(response)
        if (json_response.code === 0){
          this.text = json_response.data[0].body
          setTimeout(() => {
            this.$refs.loadingPage.end()
            this.loading = false
          }, 600)
        } else {
          toast.errorMessage(json_response.message)
        }
      }).catch((error) => {
        toast.errorMessage(error)
      })
    }
  }
}
</script>
